import type { FaireProductEntity } from "../../entity_types/product";

export const p_q4w9c6wckc: FaireProductEntity = {
  token: "p_q4w9c6wckc",
  type: "product",
  name: "Small Brass Sitting Frog Webbed Feet Figurine",
  brandToken: "b_q8ypma3xp2",
  brandName: "Superior Stones & Gifts INTL LLP",
  imageUrl:
    "https://cdn.faire.com/fastly/665e5b3690ef3e09bcdc8e8d8eaf07f1ac089d0c2b0d8f30a14de41c58a724b5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f5cd8faa83ff9adc535cc56662bfd63415b3d32e01eef4ab4ca2daee5cd389ed.jpeg",
    "https://cdn.faire.com/fastly/d9e335e201b321ea8737f38e58b892ed7a49c92f62bc0c51dd39db4f99af9b1a.jpeg",
  ],
  priceDollars: 3.6,
  description:
    "Small Brass Sitting Frog Webbed Feet Figurine, quality castings with good details.\n\nMeasures 35x20mm\n\nThis charming brass frog strikes a delightful pose with perfectly detailed webbed feet, ready to add a whimsical touch to any space. Crafted with care, this petite figurine captures the character and charm of everyone's favorite amphibian. Whether displayed on a shelf, desk, or garden windowsill, it's a conversation starter that brings personality and a hint of nature-inspired fun to your décor. A perfect gift for frog enthusiasts and collectors alike!\n",
  tags: [],
  msrpDollars: 7.21,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:32.280Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
